import md5 from 'js-md5';

/**
 * 生成验证码接口需要的code参数
 * @returns {string} 生成的code
 */
export const generateSmsCode = () => {
    // 获取当前时间戳
    const timestamp = Date.now();
    // 生成key：xuematech + 当前年份
    const key = `xuematech2026`;
    // 组合时间戳和key
    const combined = `${timestamp}${key}`;
    // 使用md5生成code
    const code = md5(combined);
    return {
        timestamp,
        code
    };
};
